module.exports = __webpack_public_path__ + "img/385.a73f423a.png";